import { createTheme } from '@mui/material/styles';

// MUI v5 테마 설정 - 기존 디자인 시스템과 일치
const muiTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3b82f6',
      dark: '#2563eb',
      darker: '#1d4ed8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#6b7280',
      dark: '#4b5563',
      contrastText: '#ffffff',
    },
    error: {
      main: '#ef4444',
      dark: '#dc2626',
      light: '#fca5a5',
      lighter: '#fee2e2',
      contrastText: '#ffffff',
    },
    success: {
      main: '#10b981',
      dark: '#059669',
      contrastText: '#ffffff',
    },
    grey: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#111827',
      secondary: '#6b7280',
    },
  },
  typography: {
    fontFamily: 'inherit',
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 6,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          transition: 'all 0.2s ease',
          '&:hover': {
            transform: 'translateY(-1px)',
          },
          '&:active': {
            transform: 'translateY(0)',
          },
          '&:disabled': {
            opacity: 0.5,
            transform: 'none',
          },
          '&:focus': {
            outline: '2px solid #3b82f6',
            outlineOffset: 2,
          },
        },
        sizeSmall: {
          padding: '6px 12px',
          fontSize: '0.875rem',
          minHeight: 32,
        },
        sizeMedium: {
          padding: '8px 16px',
          fontSize: '0.875rem',
          minHeight: 36,
        },
        sizeLarge: {
          padding: '12px 24px',
          fontSize: '1rem',
          minHeight: 44,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#2563eb',
          },
          '&:active': {
            backgroundColor: '#1d4ed8',
          },
        },
        containedSecondary: {
          '&:hover': {
            backgroundColor: '#4b5563',
          },
        },
        containedError: {
          '&:hover': {
            backgroundColor: '#dc2626',
          },
        },
        containedSuccess: {
          '&:hover': {
            backgroundColor: '#059669',
          },
        },
        outlined: {
          borderWidth: 1,
          '&:hover': {
            borderWidth: 1,
          },
        },
        outlinedPrimary: {
          borderColor: '#3b82f6',
          color: '#3b82f6',
          '&:hover': {
            backgroundColor: '#3b82f6',
            borderColor: '#3b82f6',
            color: '#ffffff',
          },
        },
        outlinedSecondary: {
          borderColor: '#6b7280',
          color: '#6b7280',
          '&:hover': {
            backgroundColor: '#6b7280',
            borderColor: '#6b7280',
            color: '#ffffff',
          },
        },
        outlinedError: {
          borderColor: '#fca5a5',
          color: '#dc2626',
          '&:hover': {
            backgroundColor: '#fee2e2',
            borderColor: '#ef4444',
            color: '#dc2626',
          },
        },
        text: {
          color: '#6b7280',
          '&:hover': {
            backgroundColor: '#f3f4f6',
            color: '#374151',
          },
        },
      },
      defaultProps: {
        disableElevation: true,
        disableRipple: false,
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 8,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        },
        sizeSmall: {
          padding: 6,
        },
        sizeLarge: {
          padding: 12,
        },
      },
    },
  },
});

// 다크 모드 테마
export const muiDarkTheme = createTheme({
  ...muiTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#3b82f6',
      dark: '#2563eb',
      darker: '#1d4ed8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#d1d5db',
      dark: '#9ca3af',
      contrastText: '#000000',
    },
    error: {
      main: '#ef4444',
      dark: '#dc2626',
      light: '#fca5a5',
      contrastText: '#ffffff',
    },
    success: {
      main: '#10b981',
      dark: '#059669',
      contrastText: '#ffffff',
    },
    grey: {
      50: '#111827',
      100: '#1f2937',
      200: '#374151',
      300: '#4b5563',
      400: '#6b7280',
      500: '#9ca3af',
      600: '#d1d5db',
      700: '#e5e7eb',
      800: '#f3f4f6',
      900: '#f9fafb',
    },
    background: {
      default: '#111827',
      paper: '#1f2937',
    },
    text: {
      primary: '#f9fafb',
      secondary: '#d1d5db',
    },
  },
  components: {
    ...muiTheme.components,
    MuiButton: {
      ...muiTheme.components.MuiButton,
      styleOverrides: {
        ...muiTheme.components.MuiButton.styleOverrides,
        text: {
          color: '#d1d5db',
          '&:hover': {
            backgroundColor: '#374151',
            color: '#f9fafb',
          },
        },
        outlinedSecondary: {
          borderColor: '#6b7280',
          color: '#d1d5db',
          '&:hover': {
            backgroundColor: '#6b7280',
            borderColor: '#6b7280',
            color: '#000000',
          },
        },
      },
    },
  },
});

export default muiTheme;